import styled, { css } from "react-emotion";
import { isMobileDevice } from "helpers";

const isMob = isMobileDevice();
export const P = styled("p")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  display: block;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
`;

export const arrowContainer = css`
  margin: 0px 20px;
  @media only screen and (min-width: 768px) {
    margin: 0px 40px;
  }
`;

export const arrowStyle = css`
  font-size: 1.3em;
  display: flex;
  align-self: flex-end;
  margin-top: 10px;
  margin-bottom: 10px;
  color: #465362;
  @media only screen and (min-width: 768px) {
    font-size: 2em;
    cursor: pointer;
    display: flex;
    align-self: flex-end;
    margin-top: 10px;
    margin-bottom: 10px;
  }
`;

export const headerText = css`
  text-align: center;
  font-size: 1.2em;
  margin: 0px;
  @media only screen and (min-width: 768px) {
    text-align: center;
    font-size: 1.5em;
    margin: 0px;
  }
`;

export const headerContainer = css`
  height: 25px;
  align-items: center;
  margin: 10px 0px;
  justify-content: center;
  @media only screen and (min-width: 768px) {
    height: 25px;
    align-items: center;
    margin: 20px 0px;
    justify-content: center;
  }
`;

export const textContainer = css`
  margin-left: auto;
  margin-right: auto;
  height: 100vh;
  display: flex;
  align-items: center;
`;

export const textContainerTop = css`
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
`;

export const FloatingButton = styled("button")`
  align-items: center;
  text-align: center;
  font-size: 15px;
  line-height: 29px;
  border-radius: 5.5px;
  background-color: #465362;
  font-weight: bold;
  box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
  font-style: normal;
  font-stretch: normal;
  text-transform: none;
  color: white;
  border: 1px #465362 solid;
  padding: 10px;
  width: ${(props) => (isMob ? "280px" : props.width * 0.9)};
  margin: auto;

  margin-bottom: 5px;
  cursor: pointer;
  :hover {
    text-decoration: underline;
  }
  @media only screen and (min-width: 768px) {
    width: 450px;
  }
`;

export const FloatingIconBottomRight = styled("div")`
  position: absolute;
  /* width: 60;
  height: 60; */
  font-size: 4rem;
  align-items: center;
  justify-content: center;
  right: 20px;
  bottom: 20px;
`;

export const FloatingIconTopRight = styled("div")`
  position: absolute;
  /* width: 60;
  height: 60; */
  /* font-size: 4rem; */
  align-items: center;
  justify-content: center;
  right: 20px;
  top: 10px;
`;

export const FloatingIconTopLeft = styled("div")`
  position: absolute;
  /* font-size: 1.25rem; */
  align-items: center;
  justify-content: center;
  left: 20px;
  top: 10px;
`;
